import React from 'react';
import {InsightRoute} from "../../routes/MainRoute";

export default function Insights(){
    return(
        <div>
            <InsightRoute/>
        </div>
    )
}